import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  getAuth,
  initializeAuth,
  indexedDBLocalPersistence
} from "firebase/auth";
import { getStorage } from "firebase/storage";
import { Capacitor } from "@capacitor/core";

const firebaseConfig = {
  apiKey: "AIzaSyBOVM-LUS6To37F_fzWWx-mMfPPg94FUdc",
  authDomain: "onewast.firebaseapp.com",
  projectId: "onewast",
  storageBucket: "onewast.firebasestorage.app",
  messagingSenderId: "352811598736",
  appId: "1:352811598736:web:07eca0a7a7e857b7a1e915"
};
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

export const auth = Capacitor.isNativePlatform()
  ? initializeAuth(app, {
      persistence: indexedDBLocalPersistence
    })
  : getAuth(app);

export const storage = getStorage(app);


